import SelectorEngine from '../../utils/dom/selector-engine';
import FormComponent from '../FormComponent';
import Request from '../../utils/request';

class FormTable extends FormComponent {
	constructor(element, config) {
		super(element, config);
	}
	markup(value, data, titleMarkup) {
		return `
            <div class="lta-form-table u-mb-5">
				<div class="lta-form-table-title">${titleMarkup}</div>
                <div class="lta-form-table--container">
					<div class="lta-form-table--data u-mb-2 lta-match-table">
                        <div class="lta-richtext u-p-2">
                            <div class="table-responsive">
                                <table class="table u-mb-6">
                                    <thead class="lta-form-table-header">
                                        <tr class="u-text-grey-ui-mid u-body2"></tr>
                                    </thead>
                                    <tbody class="lta-form-table-body"></tbody>
                                </table>
                            </div>
                        </div>
		            </div>
                </div>
			</div>
        `;
	}

	afterRender(data) {
		this.fetchData(data);
	}

	async fetchData(data) {
		try {
			const response = await Request.get(data.apiUrl);
			if (response) {
				if (Number(response?.courses.length) !== 0) {
					this.tableHeader = SelectorEngine.findOne('.lta-form-table-header > tr', this._element);
					this.tableBody = SelectorEngine.findOne('.lta-form-table-body', this._element);
					const tableHeaderElement = Object.keys(response?.courses[0])
						.map((items) => this.headerRenderer(items))
						.join('');
					this.tableHeader.innerHTML = tableHeaderElement;
					const tableBodyElement = response?.courses.map((rowData, index) => this.rowRenderer(rowData, index)).join('');
					this.tableBody.innerHTML = tableBodyElement;
				} else {
					this.noContentText = SelectorEngine.findOne('.lta-richtext', this._element);
					const noDataMarkup = `<div class="u-text-grey-ui-mid u-body">You haven't completed any courses this year</div>`;
					this.noContentText.innerHTML = noDataMarkup;
				}
			}
		} catch {}
	}

	headerRenderer(item) {
		// Exclude the 'Credits' column from the header
		if (item !== 'Credits') {
			return `<th class="u-pr-3">${item}</th>`;
		}
		return '';
	}

	rowRenderer(rowData, index) {
		const filteredRowData = Object.keys(rowData)
			.filter((key) => key !== 'Credits')
			.map((key) => `<td class="u-pr-3">${rowData[key]}</td>`)
			.join('');

		return `<tr class="u-text-grey-ui-mid u-body2">${filteredRowData}</tr>`;
	}
}

export default FormTable;
